/**
 * GetFavouriteHashTagsUseCase
 *
 * Loads favourite hashtags from SecureStorage, sorted by localUses descending,
 * returns top 5. Called when user types '#' with no text after it.
 * Matches Flutter's _getLocalFavouriteHashTags in set_content_description_screen.dart.
 */

import type { ContentTagEntity } from '@/domain/entities/contentTag/contentTagEntity';
import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';

const MAX_FAVOURITES = 5;

export class GetFavouriteHashTagsUseCase {
  private storage: SecureStorageWebCrypto;

  constructor(storage?: SecureStorageWebCrypto) {
    this.storage = storage ?? SecureStorageWebCrypto.getInstance();
  }

  async execute(): Promise<ContentTagEntity[]> {
    const allTags = await this.storage.getAllWithPrefix<ContentTagEntity>(
      SECURE_STORAGE_KEYS.FAVOURITE_HASHTAGS,
    );

    if (allTags.length === 0) return [];

    // Sort by localUses descending (most used first)
    allTags.sort((a, b) => b.localUses - a.localUses);

    return allTags.slice(0, MAX_FAVOURITES);
  }
}

export const createGetFavouriteHashTagsUseCase = () => new GetFavouriteHashTagsUseCase();
